export const TRUE_CALL_SIDEBAR_MENU_COUNT = "TRUE_CALL_SIDEBAR_MENU_COUNT";
export const FALSE_CALL_SIDEBAR_MENU_COUNT = "FALSE_CALL_SIDEBAR_MENU_COUNT";